import { render, staticRenderFns } from "./templateTransition.vue?vue&type=template&id=e08c053c&scoped=true"
import script from "./templateTransition.vue?vue&type=script&lang=js"
export * from "./templateTransition.vue?vue&type=script&lang=js"
import style0 from "./templateTransition.vue?vue&type=style&index=0&id=e08c053c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08c053c",
  null
  
)

export default component.exports